import { GET_VIZLINKSHOPS_REQUESTS } from "../../../Types";
// import _ from 'lodash'

const VizShopsRequestListingReducer = (state = [], action) => {
  switch (action.type) {
    case GET_VIZLINKSHOPS_REQUESTS:
      return [...action.payload];
    default:
      return state;
  }
};
export default VizShopsRequestListingReducer;
